import { headerHabitat as Component } from './header';
export default Component;
